import { pushAnalyticsObjToDataLayer } from "@/utils/helper"

export const getAnalyticsData = (type, url, needsJSON = false) => {
  const title = type.toLowerCase().trim()
  let eventAction
  let internalLinkZoneName
  let internalLinkURL
  const { adobeDataLayer: { getState } = {} } = window
  const page = (getState && getState("page")) || {}
  if (title === "notify me") {
    internalLinkZoneName = `${page?.category?.pageType}:modal:availability notification`
    eventAction = `${internalLinkZoneName}:${title}`
  } else if (title === "local store or showroom") {
    eventAction = `${page?.category?.pageType}:product details:add-on services:${title}`
    internalLinkURL = `${url.toLowerCase().trim()}`
  } else if (title === "where to buy") {
    internalLinkURL = `${window.location.origin + url}`
  }
  const eventInfo = {
    eventAction:
      eventAction || `${page?.category?.pageType}:product details:${title}`,
    eventName:
      eventAction || `${page?.category?.pageType}:product details:${title}`,
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: `${title}`,
    internalLinkPosition: `${page?.category?.pageType}`,
    internalLinkType: `${page?.category?.pageType}:${title}`,
    internalLinkZoneName:
      internalLinkZoneName || `${page?.category?.pageType}:product details`,
    internalLinkURL: internalLinkURL || "n/a",
    clickInternalLinks: "true",
  }
  if (needsJSON) {
    return eventInfo
  }
  return JSON.stringify(eventInfo)
}

export const replaceAddToCartDatalayerPush = (
  replaceAddToCartCtaLabel,
  replaceAddToCartCtaLink,
  analyticData
) => {
  const eventInfo = getAnalyticsData(
    replaceAddToCartCtaLabel,
    replaceAddToCartCtaLink,
    true
  )
  const page = window.adobeDataLayer.getState("page")
  analyticData = JSON.parse(analyticData)
  const productInfo = analyticData?.productInfo
  window.adobeDataLayer.push({
    event: "cmp:click",
    eventInfo,
    productInfo,
    page,
  })
}

export const addToCompareAnalytics = isChecked =>
  `{"eventAction":"pdp:product details: ${
    isChecked ? "remove" : "add to"
  } compare","eventName":"pdp:product details: ${
    isChecked ? "remove" : "add to"
  } compare","eventType":"n/a","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"${
    isChecked ? "remove" : "add to"
  } compare","internalLinkPosition":"pdp","internalLinkType":"pdp:${
    isChecked ? "remove" : "add to"
  } compare","internalLinkZoneName":"pdp:product details","internalLinkURL":"n/a","clickInternalLinks":"true"}`

export const quantityOutOfStockAnalytics = (productInfo, pincode) => {
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: "pdp:product details:check availability",
    eventName: "pdp:product details:check availability",
    eventType: "navigation",
    internalLinkName: "check availability",
    internalLinkPosition: "pdp",
    internalLinkType: `pdp:${pincode}`,
    internalLinkZoneName: "pdp:product details",
    internalLinkURL: "n/a",
  }
  const outOfStockInfo = {
    availability: "out_of_stock",
    errorMessage:
      "This product is currently unavailable. Please check back later.",
    productStatus: "out of stock",
    pincode: pincode,
  }
  productInfo = { ...productInfo, ...outOfStockInfo }
  const customDataLayer = { productInfo }
  pushAnalyticsObjToDataLayer(eventInfo, "cmp:click", {}, customDataLayer)
}

export const gtmAddToCartEvent = ({productInfo, utmPayload})=>{
  const {utm_source="", utm_medium=""} = utmPayload || {}
  const {productSalePrice="",category="", quantity="", productName="", productID="" } = productInfo || {}
  window.dataLayer.push({
    "event": "add_to_cart",
    "source":utm_source,
    "medium":utm_medium,
    "ecommerce": {
      "currency": "INR",
      "value": productSalePrice,
      "items": [
        {
          "item_id": productID,
          "item_name": productName,
          "item_category": category,
          "quantity": quantity
        }
      ]
    }
  })
}
